import { render, staticRenderFns } from "./task_allot_batch.vue?vue&type=template&id=330e0cf5&scoped=true"
import script from "./task_allot_batch.vue?vue&type=script&lang=js"
export * from "./task_allot_batch.vue?vue&type=script&lang=js"
import style0 from "./task_allot_batch.vue?vue&type=style&index=0&id=330e0cf5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e0cf5",
  null
  
)

export default component.exports